export default {"src":"kbwebsite/assets/_next/static/media/download_apple_store.4d87394d.svg","height":42,"width":144};